@use "../../style/variables" as *;
@use "../../style/mixins" as *;

$marginTop: 2.25rem;

.couponDetails {
  max-width: 100%;
  min-height: 100%;
  background-color: $white;
  margin-left: auto;
  margin-right: 0;
  display: table;
  align-items: flex-start;

  @include mobile {
    margin-top: 0;
    margin-right: auto;
  }

  .column {
    display: inline-block;
    vertical-align: top;

    &.left {
      margin-right: 2.375rem;
      top: $marginTop;

      @include mobile {
        display: none;
      }
    }
  }

  .pageHeader {
    display: none;
    @include mobile {
      display: block;
    }
  }
}

.errorNoCoupon {
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo {
    max-width: 6rem;
    margin-top: 2.25rem;

    @include tablet {
      display: none;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .errorMessage {
    margin: 2.25rem 0;
    font-size: 1rem;
    text-align: center;
    line-height: 1.5rem;
    color: $grey-text;
    padding: 0 2.5rem;
    font-weight: 300;

    @include tablet {
      font-size: 1.5rem;
      line-height: 2.25rem;
      margin-top: 0;
    }
  }

  .backButton {
    background: $grey;
    font-size: 0.875rem;
    line-height: 0.875rem;
    letter-spacing: 0.7px;
    padding: 0.875rem 2.25rem;
    text-transform: uppercase;
    text-decoration: none;
    color: $white;
    cursor: pointer;

    @include tablet {
      font-size: 1rem;
      line-height: 1rem;
    }
  }
}

.coupon {
  width: 37.5rem;

  @include mobile {
    width: 100%;
  }
}

.card {
  margin-bottom: 1.625rem;
  @include separator-bottom;

  @include mobile {
    margin-bottom: 1rem;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .rich-media {
    cursor: pointer;
    position: relative;
    padding-top: 56.25%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: $black;
  }

  .supporting-text {
    margin-top: 1rem;

    @include mobile {
      margin-left: 0;
      margin-right: 0;
    }

    .couponHeader {
      @include separator-bottom;
    }

    .title {
      font-weight: 100;
      color: $ny-red;
      font-size: 2.25rem;
      line-height: 2.625rem;

      @include mobile {
        font-size: 1.5rem;
        line-height: 1.875rem;
      }
    }

    .subtitle {
      margin-top: 0.75rem;
      padding-bottom: 1.25rem;
      font-weight: 300;
      color: $grey-text;
      font-size: 1.25rem;
      line-height: 1.5rem;

      @include mobile {
        font-size: 1rem;
        line-height: 1.125rem;
        margin-top: 0.375rem;
        padding-bottom: 0.625rem;
      }
    }

    .body {
      font-weight: 300;
      font-size: 1.125rem;
      color: $grey-text;
      line-height: 1.5rem;
      margin-top: 1.25rem;
      padding-bottom: 1.25rem;
      @include separator-bottom;

      @include mobile {
        font-size: 0.875rem;
        line-height: 1.125rem;
        margin-top: 1.25rem;
        padding-bottom: 1.25rem;
      }
    }

    .no-border {
      border-bottom: none;
    }

    .legalText {
      color: #888888;
      font-weight: 300;
      font-size: 0.875rem;
      line-height: 1.125rem;
      margin-top: 1.875rem;
      padding-bottom: 2.375rem;

      @include mobile {
        font-size: 0.75rem;
        line-height: 1.125rem;
        margin-top: 1.5rem;
        padding-bottom: 1.25rem;
      }
    }

    button {
      margin-top: 0;
      font-size: 1.125rem;
      border-radius: 9px;
      width: 16rem;
      height: 3.25rem;


      @include mobile {
        font-size: 0.875rem;
        width: 13.125rem;
        height: 2.875rem;
      }
    }

    .date-container {
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;

      &:empty {
        margin-top: 0;
        margin-bottom: 1.25rem;
      }

      .date {
        display: flex;
        justify-content: center;

        font-size: 0.875rem;
        line-height: 0.875rem;
        color: #888888;

        @include mobile {
          font-size: 0.625rem;
          line-height: 0.75rem;
        }

        .validity {
          margin-left: 0.25rem;
        }
      }
    }
  }

  .pointsContainer {
    position: relative;
  }

  .points {
    position: absolute;
    bottom: 1.25rem;
    right: 1.25rem;
    width: 5rem;
    height: 3.125rem;
    border-radius: 8px;
    color: $white;
    background-color: $grey-text;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @include mobile {
      bottom: 0.875rem;
      right: 1rem;
      width: 4rem;
      height: 2.5rem;
      border-radius: 6px;
    }

    .pointsValue {
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1.125rem;

      @include mobile {
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1rem;
      }
    }

    .pointsText {
      font-weight: 100;
      font-size: 0.75rem;
      text-transform: uppercase;
      line-height: 0.75rem;
      letter-spacing: 0.075rem;

      @include mobile {
        font-size: 0.625rem;
        line-height: 0.625rem;
      }
    }
  }
}

.icon {

  &.calendar svg {
    width: 0.875rem;
    height: 0.875rem;
    vertical-align: center;

    @include mobile {
      width: 0.625rem;
      height: 0.625rem;
    }
  }

  &.arrow svg {
    width: 2.25rem;
    height: 2.25rem;
    vertical-align: center;
    cursor: pointer;

    &:hover {
      fill: #888888;
    }
  }
}

/* Solid icons get a fill */
.solid {
  fill: $grey-light;
  stroke: none
}

.phone {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.registrationContainer {
  display: none;
  margin: 0 .75rem;

  &.show {
    display: block;
  }
}